import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Box,
  Button,
} from "@mui/material";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import { IQuotesByDestination } from "../../../types/IQuotes";
import { NitroMarkerBase } from "../../../components/map/components/NitroMarker";
import { toCamelCase } from "../../../utils/String";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { IOccupant } from "../../../types/ILocation";
import NitroService from "../../../utils/nitro.service";
import { useNitroStore } from "../../../store/Store";

// TODO: adding product should expand destination but doesn't
interface TableProps {
  destinations: IQuotesByDestination[];
}

export const MissingProductTable: React.FC<TableProps> = ({ destinations }) => {
  const [product, openInsightsPanel, setMultiLocationDestinations] =
    useNitroStore((state) => [
      state.product,
      state.openInsightsPanel,
      state.setMultiLocationDestinations,
    ]);
  const triggerRefetchQuotes = useNitroCAStore(
    (state) => state.triggerRefetchQuotes,
  );
  const [
    setTroubleshootDestinationOpen,
    setDestinationToTroubleshoot,
    setExpandedDestination,
  ] = useNitroCAStore((state) => [
    state.setDisplayAddProductToDestinationPanel,
    state.setDestinationToTroubleshoot,
    state.setExpandedDestination,
  ]);
  const [hovering, setHovering] = useState({ isHovering: false, id: "" });

  const addProductToOccupant = async (
    occupant: IOccupant,
    destinationId: string,
  ) => {
    const updatedOccupant = {
      ...occupant,
      products: [...occupant.products, { product, quantity: 0 }],
    } as IOccupant;
    await NitroService.updateOccupants({
      id: destinationId,
      occupants: [updatedOccupant],
    });
  };
  return (
    <Box>
      <TableContainer>
        <Table>
          <TableBody>
            {destinations.map((entry) => {
              const isHovering =
                hovering.isHovering && hovering.id === entry.destination.id;
              return (
                <TableRow
                  sx={{
                    background: "white",
                    height: "42px",
                  }}
                >
                  {/* Destination Cell - if city pin then this cell is not a button since there is no location overview */}
                  <TableCell sx={{ borderTop: "0.5px solid #E2E8F0" }}>
                    <Button
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        paddingTop: "10px",
                        paddingLeft: "13px",
                        paddingRight: "0px",
                        paddingBottom: "0px",
                        "&:hover": { backgroundColor: "transparent" },
                      }}
                      onMouseEnter={() =>
                        setHovering({
                          isHovering: true,
                          id: entry.destination.id,
                        })
                      }
                      onMouseLeave={() =>
                        setHovering({ isHovering: false, id: "" })
                      }
                      onClick={() =>
                        openInsightsPanel(
                          entry.destination.id,
                          "Logistics",
                          false,
                        )
                      }
                    >
                      <div
                        className={
                          isHovering
                            ? styles.destinationNameHover
                            : styles.destinationName
                        }
                      >
                        {entry.destination.displayName}
                      </div>

                      <Box className={styles.locationCell}>
                        <NitroMarkerBase
                          width={12}
                          height={20}
                          type={entry.destination.pinType || ""}
                        />
                        <span className={styles.destinationLocation}>
                          {toCamelCase(entry.destination.city || "")},{" "}
                          {entry.destination.stateOrProvince}
                        </span>
                      </Box>
                    </Button>
                  </TableCell>

                  {/* Action Cell */}
                  <TableCell
                    sx={{
                      borderTop: "0.5px solid #E2E8F0",
                      paddingRight: "15px",
                    }}
                    align="right"
                  >
                    <Button
                      sx={{
                        borderRadius: "20px",
                        border: "1px solid #E2E8F0",
                        padding: "6px 8px",
                        justifyContent: "center",
                        boxShadow: "0 1px 2px 0 rgba(107, 114, 128, 0.20)",
                        alignItems: "center",
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "#2563EB",
                      }}
                      onClick={async () => {
                        // if only 1 occupant, skip asking which occupant and add product directly
                        if (entry.destination.details!.occupants.length === 1) {
                          await addProductToOccupant(
                            entry.destination.details!.occupants[0],
                            entry.destination.id,
                          );
                          // on successful add, refetch multi-location data and expand destination
                          setMultiLocationDestinations([]);
                          triggerRefetchQuotes();
                          setExpandedDestination(
                            {
                              id: entry.destination.id,
                              name: entry.destination.name,
                            },
                            {
                              expandSurroundingLocations:
                                entry.destination.isSurroundingLocation,
                            },
                          );
                        } else {
                          setDestinationToTroubleshoot(entry.destination);
                          setTroubleshootDestinationOpen(true);
                        }
                      }}
                    >
                      + Add Product
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
